import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Report.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { ReportDropOffEntity } from "../../entities/ReportEnity";
import { ReportService } from "../../services/report";
import FilterUtils from "../../utils/filter-utils";
import { LuImage } from "react-icons/lu";
import { VendorDropoffService } from "../../services/vendors_dropoff";

export default function ReportDropOff() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //

  const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});
  const [tableData, setTableData] = useState<ReportDropOffEntity[]>([]);
  const [filterDate, setFilterDate] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd")
  });
  const [selectedDropOff, setSelectedDropOff] = useState<ReportDropOffEntity | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState<number>(0);

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handlePopupDetail = (row: ReportDropOffEntity) => {
    setSelectedDropOff(row);
    setShowPopup(true)
  }

  const handleDownloadFile = async () => {
    if (selectedDropOff == null || selectedDropOff?.penerima == null) return;
    try {
      const resp = await VendorDropoffService.GetFileVendorDropoff(selectedDropOff);
      const file_length = parseInt(resp.headers.get('Content-Length') ?? '0');
      const received = [];
      const reader = resp.body?.getReader()
      let progress = 0;
      while (true) {
        if (reader == undefined) break;
        const { done, value } = await reader.read();
        if (done) break;
        received.push(value);
        progress += value.length;
        setDownloadProgress(progress / file_length * 100)
      }
      const blob = new Blob(received, { type: resp.headers.get("Content-Type") ?? undefined });
      if (resp.status != 200) {
        contextShowLoadingFunc(false);
        return contextShowAlertFunc(new AlertEntity({ message: `[${resp.status}] Not found`, level: 3 }));
      }
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const file_name = (resp.headers.get("Content-disposition") ?? undefined).substring((resp.headers.get("Content-disposition") ?? undefined).indexOf('=') + 1);
      link.setAttribute('download', `${file_name}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      contextShowLoadingFunc(false);
      setDownloadProgress(0)
      return contextShowAlertFunc(new AlertEntity({ message: '[Success]', level: 1 }));
    } catch (error: any) {
      contextShowLoadingFunc(false);
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    }
  }

  const handleGenerateExcel = async () => {
    if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
    const column = ["waktu_tapping", "shift", "vendor", "lokasi_dropoff", "requestor", "penerima", "jumlah_porsi"];
    let values: { [key: string]: string }[] = [];
    let dataForExport = tableData.filter((row) => {
      return FilterUtils.FilterTable(row, tableDataFilter)
    })
    for (let i = 0; i < dataForExport.length; i++) {
      values.push({
        waktu_tapping: dataForExport[i].datetime_in,
        shift: dataForExport[i].shift.toString(),
        vendor: dataForExport[i].vendor,
        lokasi_dropoff: dataForExport[i].lokasi_dropoff,
        requestor: dataForExport[i].requestor,
        penerima: dataForExport[i].penerima,
        jumlah_porsi: dataForExport[i].jumlah_porsi.toString(),
      })
    }
    ExcelUtils.export(`Tapping List on ${filterDate.start_date} until ${filterDate.end_date}`, column, values);
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await ReportService.ReportDropoff(filterDate.start_date, filterDate.end_date);
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Report Drop Off"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>Start Date :</label>
                  <input style={{ fontSize: "12px" }} type="date" value={filterDate.start_date}
                    onChange={(event) => setFilterDate(prevState => ({
                      ...prevState,
                      start_date: event.target.value
                    }))}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>End Date :</label>
                  <input style={{ fontSize: "12px" }} type="date" value={filterDate.end_date}
                    onChange={(event) => setFilterDate(prevState => ({
                      ...prevState,
                      end_date: event.target.value
                    }))}
                  />
                </div>
                <div>
                  <div style={{ color: "white", textAlign: "left" }}>&nbsp;</div>
                  <button className="cardButton" onClick={() => generateData()} >
                    Refresh
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => handleGenerateExcel()} >
                    Generate Excel
                  </button>
                </div>
              </div>
              <div className={css.rowGrid} style={{ alignItems: 'end', marginTop: "1vh" }}>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>shift :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, shift: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>vendor :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, vendor: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>lokasi drop off :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, lokasi_dropoff: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>requestor :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, requestor: event.target.value }));
                    }}
                  />
                </div>
                <div>
                  <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>penerima :</label>
                  <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.bulan ?? null}
                    onChange={(event) => {
                      setTableDataFilter((prev) => ({ ...prev, penerima: event.target.value }));
                    }}
                  />
                </div>
              </div>
            </>
          }
        />
        <div
          style={{
            height: "65vh",
            overflow: "auto"
          }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Waktu Tapping</th>
                    <th>Shift</th>
                    <th>Vendor</th>
                    <th>Lokasi</th>
                    <th>Lokasi Drop Off</th>
                    <th>Requestor</th>
                    <th>Penerima</th>
                    <th>Jumlah Porsi</th>
                    <th>Foto</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.filter((row) => {
                    return FilterUtils.FilterTable(row, tableDataFilter)
                  })
                    .map((row, idx) => {
                      return <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{row.datetime_in}</td>
                        <td>{row.shift}</td>
                        <td>{row.vendor}</td>
                        <td>{row.lokasi}</td>
                        <td>{row.lokasi_dropoff}</td>
                        <td>{row.requestor}</td>
                        <td>{row.penerima}</td>
                        <td>{row.jumlah_porsi}</td>
                        <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><LuImage /></td>
                      </tr>
                    })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>

        {/* Popup Foto */}
        <Popup
          setShowPopup={setShowPopup}
          showPopup={showPopup}
          popupTitle={`Foto Drop Off Ke ${selectedDropOff?.lokasi_dropoff} (${selectedDropOff?.requestor})`}
          popupContent={
            <>
              <div className={css.form}>
                <div className={css.containerleftright}>
                  <div className={css.leftposition}><div className={css.label}> Bukti Foto <span style={{ color: "red" }}>*</span></div>
                    <button className={(selectedDropOff?.penerima ? "primaryButton" : "primaryButtonNoClick")} style={{ flexDirection: "column", justifyContent: "start", alignItems: "start" }}
                      onClick={async () => { handleDownloadFile() }} >
                      <div>
                        Download File
                      </div>
                      <div style={{ width: `${downloadProgress}%`, height: "2px", backgroundColor: "#17A8C5" }} />
                    </button>
                  </div>
                </div>
                <div className={css.buttons2}>
                  <div className={css.left}>
                    <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </div>
    </>
  );
}
